import { AuthFlow as AuthFlowProvider } from "./auth-flow";
import { AuthFlowHeader } from "./auth-flow-header";
import { AuthDivider } from "./divider";
import { MethodSwitch } from "./method-switcher";
import { EmailLinkMethod } from "./methods/email-link";
import { GoogleMethod } from "./methods/google";
import { MicrosoftMethod } from "./methods/microsoft";
import { PasswordMethod } from "./methods/password";
import { PhoneMethod } from "./methods/phone";

export { AuthFlow as AuthFlowProvider } from "./auth-flow";
export { useAuthFlow } from "./auth-flow-context";
export { AuthShell } from "./auth-shell";
export * from "./types";
export { normalizeAuthError } from "./use-auth-error";

type AuthFlowNamespace = typeof AuthFlowProvider & {
  Header: typeof AuthFlowHeader;
  Password: typeof PasswordMethod;
  Google: typeof GoogleMethod;
  Microsoft: typeof MicrosoftMethod;
  Phone: typeof PhoneMethod;
  EmailLink: typeof EmailLinkMethod;
  Divider: typeof AuthDivider;
  MethodSwitch: typeof MethodSwitch;
};

const AuthFlowWithMethods = AuthFlowProvider as AuthFlowNamespace;
AuthFlowWithMethods.Header = AuthFlowHeader;
AuthFlowWithMethods.Password = PasswordMethod;
AuthFlowWithMethods.Google = GoogleMethod;
AuthFlowWithMethods.Microsoft = MicrosoftMethod;
AuthFlowWithMethods.Phone = PhoneMethod;
AuthFlowWithMethods.EmailLink = EmailLinkMethod;
AuthFlowWithMethods.Divider = AuthDivider;
AuthFlowWithMethods.MethodSwitch = MethodSwitch;

export const AuthFlow = AuthFlowWithMethods;
export { TAndSFooter } from "./methods/phone/t-and-s-footer";
export {
  GoogleSignUpContinuation,
  PortalSignUp,
  useGoogleSignUpContinuation,
  useSignUpAuth,
} from "./sign-up";
export type { GoogleSignUpEntry, PendingGoogleSignUp } from "./sign-up";
export {
  usePhoneAuth,
  usePhoneAuthOptional,
  PhoneAuthStep,
} from "./methods/phone/phone-auth-context";
